// components/ui/Breadcrumb/index.tsx
// Thuần UI — nhận mảng items, render breadcrumb

import { Link } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string
  path?: string // Nếu không có path = item cuối (current)
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  dark?: boolean // Dark mode (dùng trong hero tối)
  className?: string
}

const Breadcrumb = ({ items, dark = false, className = '' }: BreadcrumbProps) => {
  return (
    <nav
      className={`breadcrumb ${dark ? 'page-hero__breadcrumb' : ''} ${className}`}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <span key={index} className="breadcrumb-item">
            {!isLast && item.path ? (
              <Link to={item.path}>{item.label}</Link>
            ) : (
              <span className={isLast ? 'current' : ''}>{item.label}</span>
            )}
            {!isLast && <span className="separator">/</span>}
          </span>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
